import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import getInitialStates from './initial_states';

import { LOCAL_STORAGE } from '../config/constants';
import { RESET_REDUX_STATE } from './admin_details/actiontypes';

import admin_details from './admin_details/reducers';
import member_details from './member_details/reducers';
import botbuilder_details from './botbuilder_details/reducers';
import botmessage_details from './botmessage_details/reducers'
import botparams_details from './botparams_details/reducers';
import chatlog_details from './chatlog_details/reducers';
import chats_details from './chats_details/reducers';
import dashboard_details from './dashboard_details/reducers';
import entity_details from './entity_details/reducers';
import event_details from './event_details/reducers';
import feedback_details from './feedback_details/reducers';
import filter_details from './filter_details/reducers';
import history_details from './history_details/reducers';
import intent_details from './intent_details/reducers';
import nlp_details from './nlp_details/reducers';
import page_details from './page_details/reducers';
import session_flow_details from './session_flow_details/reducers';
import conversion_details from './conversion_details/reducers'
import team_member_setting_details from './team_member_setting_details/reducers';
import usage_details from './usage_details/reducers';
import kpi_details from './kpi_details/reducers';
import users_details from './users_details/reducers';
import agent_monitoring_details from './agent_monitoring_details/reducers';
import downtime_details from './downtime_details/reducers';
import brand_functions_details from './brand_function_details/reducers'
import query_details from './query_details/reducers';
import model_accuracy_details from './model_accuracy_details/reducers'
import apilogs_details from './apilogs_details/reducers'
import reports_details from './reports_details/reducers'
import fracture_details from './fracture_details/reducers'

const appReducer = combineReducers({
  page_details,
  chats_details,
  admin_details,
  member_details,
  filter_details,
  history_details,
  nlp_details,
  dashboard_details,
  usage_details,
  chatlog_details,
  session_flow_details,
  conversion_details,
  feedback_details,
  botbuilder_details,
  botmessage_details,
  intent_details,
  entity_details,
  event_details,
  team_member_setting_details,
  users_details,
  botparams_details,
  agent_monitoring_details,
  kpi_details,
  downtime_details,
  brand_functions_details,
  query_details,
  model_accuracy_details,
  apilogs_details,
  reports_details,
  fracture_details,
  routing: routerReducer
});

const rootReducer = (state, action) => {
  if (action.type === RESET_REDUX_STATE) {
    localStorage.removeItem(LOCAL_STORAGE.ORI_ADMIN);
    localStorage.removeItem(LOCAL_STORAGE.BIFURCATION_DATA);
    state = { ...state, ...getInitialStates() };
  }
  return appReducer(state, action);
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/data/redux/index.js